import { Component, OnInit } from '@angular/core';

import { PlantMapService } from '../services/plant-map.service';

import { PageNavigationService } from '../../shared/services/page-navigation.service';
import { LayoutService } from '../../shared/services/layout.service';
import { StorageService } from '../../shared/services/storage.service';
import { PopupService } from 'app/shared/services/pop-up.service';

import { STATIC_VALUE } from '../../shared/configuration/static.value';

@Component({
    selector: 'plantmap-payment',
    templateUrl: 'payment.component.html'
})

export class PlantmapPaymentComponent implements OnInit{

    vShow : boolean;
    vpayment : string;
    vSearchVal: string = "";

    constructor(
        private _plantmapService: PlantMapService,
        private _layoutService: LayoutService, 
        private _pageNavigationService: PageNavigationService,
        private _storageService: StorageService,
        private _popupService: PopupService
    ) {
        
    }

    ngOnInit() {
    	this._layoutService.setCurrentPage('plantmap-payment');
        this._plantmapService.resetPlantMapData();
        this._plantmapService.resetPaymentData();
        this.checkIsPaymentPending();
        this.vShow = false;
    }

    getPaymentData(){
        return this._plantmapService.getPaymentData();
    }

    needPayment(){
        return this._plantmapService.needPayment();
    }

    isDisableSubmitPayment(){
        return this._plantmapService.isDisablePayment();
    }

    isLoading(){
        return this._plantmapService.isLoading();
    }

    checkIsPaymentPending() {
        if(this._plantmapService.getIsPaymentPending() === true) {
            this._popupService.openGeneralConfirmationPopup('Notice', 'Your payment was unsuccessful, please try again.', '', false, false);
            this._plantmapService.setIsPaymentPending(false);
        }
    }

    submitPayment(){ 
        this.vShow = true;
        this._plantmapService.submitPayment();
    }

    goBack(){
       // alert(this._plantmapService.vAreaOfInterestData.flow);
        if(this._plantmapService.vAreaOfInterestData.restricted_area === 1 && this._plantmapService.vAreaOfInterestData.flow  =='restricted'){
            this._pageNavigationService.navigate(['plant-map/upload-document']);    
        } else if(this._plantmapService.vAreaOfInterestData.flow  == 'normal') {
            this._pageNavigationService.navigate(['plant-map/area-of-interest']);
        } else{
            this._pageNavigationService.navigate(['customer-history']);
        }
    }

    getPaymentMethod() {
		return STATIC_VALUE.PAYMENT_METHOD;
    }

    TermsAndConditionsforPayment()
    {
        this._popupService.openPopup( 'confirmation', {
            title: 'Terms & Condition',
            message: STATIC_VALUE.TERMS_AND_CONDITIONS_PURCHASE,
            buttons: {
                CANCEL: {
                    text: 'Disagree',
                    function: () => {
                        this._popupService.closeConfirmationPopup();
                    }
                },
                OK: {
                    text: 'Agree',
                    function: () => {
                        if(this.isDisableSubmitPayment()) {
                            return this._plantmapService.isDisablePayment();;
                        } else {
                            this._plantmapService.submitPayment();
                        }
                        this._popupService.closeConfirmationPopup();
                    }
                }
            }}
        );
    }

    searchval()
    {
        this.vSearchVal = this._plantmapService.vEarthworkDetailsData.location;//kowsalya
        return this.vSearchVal;
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/plantmap/components/payment.component.ts